import { render, staticRenderFns } from "./DashboardListTable.vue?vue&type=template&id=1e5bed34&scoped=true"
import script from "./DashboardListTable.vue?vue&type=script&lang=js"
export * from "./DashboardListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5bed34",
  null
  
)

export default component.exports